import cn from "clsx";
import { forwardRef } from "react";
import { Insight } from "react-migration/components/Insight/Insight";

export const TrafficDetailSection = ({
  children,
  title,
  className,
}: {
  children: React.ReactNode;
  title?: string;
  className?: string;
}) => {
  return (
    <div
      className={cn("relative", "w-full", "flex", "flex-col", "items-start", "justify-between", "gap-y-2", className)}
    >
      {title && (
        <div
          className={cn(
            "cid-price-section-title",
            "flex",
            "flex-row",
            "items-between",
            "justify-center",
            "text-sm",
            "font-medium",
            "text-blue-grey-950"
          )}
        >
          {title}
        </div>
      )}
      {children}
    </div>
  );
};

type TrafficDetailCardProps = {
  title?: string;
  tooltip?: string;
  auxiliaryData?: string | React.ReactNode;
  auxiliaryDataSubordinate?: string | React.ReactNode;
  children?: React.ReactNode;
};

export const TrafficDetailCard = forwardRef<HTMLDivElement, TrafficDetailCardProps>(function TrafficDetailCard(
  { title, tooltip, auxiliaryData, auxiliaryDataSubordinate, children },
  ref
) {
  return (
    <Insight.Wrapper ref={ref} title={title} tooltip={tooltip}>
      <Insight.Body>{children}</Insight.Body>
      <Insight.Footer description={auxiliaryData} className="justify-between">
        {auxiliaryDataSubordinate}
      </Insight.Footer>
    </Insight.Wrapper>
  );
});

TrafficDetailCard.displayName = "TrafficDetailCard";
